<template>
  <div
    data-sidebar="group"
    :class="cn('tw:relative tw:flex tw:w-full tw:min-w-0 tw:flex-col tw:p-2', props.class)"
  >
    <slot />
  </div>
</template>

<script setup>
import { cn } from '@/shadcn/lib/utils'

const props = defineProps({
  class: { type: null, required: false },
})
</script>
